import {
  type AbstractTradeCycleEventVersion,
  isAcknowledgeTradeOrderEventVersion,
  isSentTradeOrderEventVersion,
  isTradePricesReceivedEventVersion,
} from '@festina/unitlink-general-types/unitlink'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'
import {
  createColumnDefiner,
  SortableTable,
} from '@festina-life/ui/listsAndTables'
import { useMemo } from 'react'

type Props = {
  tradeCycleEvents: AbstractTradeCycleEventVersion[]
}

const defineColumn = createColumnDefiner<AbstractTradeCycleEventVersion>()

export const TradeCycleEventsTable = ({ tradeCycleEvents }: Props) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const columns = useMemo(
    () => ({
      type: defineColumn({
        heading: translate('tradeCycle.cycle.type'),
        keyPath: '_type',
        formatter: (x) => translateEnum('enum.TradeCycleEvent', x),
      }),
      assetManagerId: defineColumn({
        heading: translate('tradeCycle.cycle.assetManagerId'),
        keyPath: undefined,
        formatter: (x) =>
          isAcknowledgeTradeOrderEventVersion(x) ||
          isSentTradeOrderEventVersion(x) ||
          isTradePricesReceivedEventVersion(x)
            ? x.assetManagerId
            : '-',
      }),
      isinKey: defineColumn({
        heading: translate('tradeCycle.cycle.isinKey'),
        keyPath: undefined,
        formatter: (x) => (
          <>
            {isTradePricesReceivedEventVersion(x)
              ? x.isinKey?.map((isin) => <div key={isin}>{isin}</div>)
              : '-'}
          </>
        ),
        sortable: false,
      }),
    }),
    [translate, translateEnum],
  )

  return <SortableTable data={tradeCycleEvents} columns={columns} />
}
